<template>
<span style="display: inline-block; margin-right: -23px;">
    

              <v-tooltip bottom>
                                    <v-btn slot="activator" 
                                            color="warning darken-2"
                                            icon
                                            flat
                                            text-color="white"
                                            dark
                                            @click.native="openModal()">
                                        <v-icon class="material-icons"  dark color="warning">edit</v-icon>
                                    

                                    </v-btn>
                                    <span>Editar coluna personalizável</span>
                </v-tooltip>


          <v-dialog @keydown.esc="dialog = false" @keydown.enter="editColumn()"   v-model="dialog" max-width="500px">
            <v-card>
            <v-card-title>
                <span><strong>Editar coluna personalizável</strong></span>
                <v-spacer></v-spacer>
                <v-menu bottom left>
                <v-list>
                    <v-list-tile>
                    <v-list-tile-title>
                        
                    </v-list-tile-title>
                    </v-list-tile>
                </v-list>
                </v-menu>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                    <h4>Nome da coluna</h4>
                    <v-text-field
                        placeholder="Ex: anotação"
                        v-model="columnName"
                        ref="inputText"
                        :rules="rules"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-switch  color="success" :label="`Acrescentar coluna nas buscas da tabela`" v-model="columnPesq"></v-switch>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="dialog=false">Cancelar</v-btn>
                <v-btn color="success"  @click.stop="editColumn()">Salvar</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

       
</span>

</template>

<script>
import NfeService from "@/domain/notas/nfe/NfeService";
export default {
  props: ["table", "item"],
  data: () => ({
    dialog: false,
    columnName: "",
    columnPesq: false,
    text: "",
    rules: [
      v => v.length <= 30 || "Máximo 30 caracteres para criação da coluna. ",
      v => !(new RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').test(v)) || "Não é possível o uso de caracteres especiais"
    ]
  }),
  watch: {},
  methods: {
    openModal: function() {
      this.dialog = true;
      this.columnName = this.item.text;
      this.columnPesq = this.item.pesq;
    },
    editColumn: function() {

      if(this.$refs.inputText.validate()){
        this.item.text = this.columnName;
        this.item.pesq = this.columnPesq;
        this.table.snack.text = `Alterações na coluna: "${this.columnName}" concluidas`;
        this.table.snackAlert();
        this.table.snack.show = true;
        this.dialog = false;
      }

      //   this.$emit("mergeColumn", obj);
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnColumn/btnEditColumn/BtnEditColumn.vue